import React, { useEffect, useState } from 'react';
import { Container } from 'reactstrap';
import Loader from '../components/common/Loader.jsx';
import Title from '../components/Title.jsx';
import Subjects from '../components/Subjects.jsx';
import MyRecentProducts from '../components/MyRecentProducts.jsx';
import MyPremiumProducts from '../components/MyPremiumProducts.jsx';
import MyClassrooms from '../components/MyClassrooms.jsx';
import MyAdministratorTools from '../components/MyAdministratorTools.jsx';
import FindContentByStandard from '../components/FindContentByStandard.jsx';
import useFetch from '../components/common/useFetch.jsx';
import ResponseErrorMessage from '../components/common/ResponseErrorMessage.jsx';
import DowntimeBanner from '../components/common/DowntimeBanner.jsx';
import checkFeatureFlag from '../components/common/checkFeatureFlag.js';

/**
 * Parent component for Dynamic Home App
 *
 * From sub-domain 'use' MyRecentProducts will not be rendered.
 */
const DynamicHome = () => {
	const [title, setTitle] = useState('');
	const [user, setUser] = useState({});
	const [isUseDomain, setIsUseDomain] = useState(false);
	const [downtimeBanner, setDowntimeBanner] = useState(false);
	const isContentRestricted = document.cookie.split(';').some(c => c.trim().startsWith('shmoop_content_restricted=1'));
	const getUserInfoService = '/internal/dynamic-home-api/Ajax/Ajax.php?action=GetUserInfo';
	const { loading, setLoading, error, response } = useFetch(getUserInfoService);

	/**
	 * Starts the navigation creations
	 */
	const createNavigation = () => {
		// This commonHeader function exists in the common repo. Be sure to keep the common minified files up to date!
		// https://gitlab.shmoop.com/shmoop/common/-/blob/master/Private/FrontEnd/js/common/navigation/_index.js
		if (typeof window.commonHeader !== 'undefined') {
			const navJson = isContentRestricted
				? '/home/Ajax/navigation-restricted.json'
				: '/home/Ajax/navigation.json';
			window.commonHeader.reinit(user, navJson);
		}
	};

	/**
	 * Creates the Wootric scripts - See documentation for more details
	 * https://app.wootric.com/account_settings/edit?account_token=NPS-8bde9d74#!/getting-started/web
	 * @param emailAddress
	 */
	const wootric = emailAddress => {
		let js = document.createElement('script');

		js.type = 'text/javascript';
		js.src = 'https://cdn.wootric.com/wootric-sdk.js';

		document.body.appendChild(js);

		// window.wootric_survey_immediately = true; // Remove for production
		window.wootricSettings = {
			email: emailAddress,
			created_at: parseInt(Date.now() / 1000, 10),
			account_token: 'NPS-8bde9d74'
		};

		// This loads the Wootric survey
		setTimeout(function() {
			if (typeof window.wootric !== 'undefined') {
				window.wootric('run');
			}
		}, 800);
	};

	/**
	 * Set the the document title when data is available
	 */
	useEffect(() => {
		document.title = title;
	}, [title]);

	/**
	 * Call the wootric method when user state is available
	 */
	useEffect(() => {
		if (typeof user.emailAddress !== 'undefined') {
			createNavigation();
			if (window.location.host === 'use.schools.com') {
				wootric(user.emailAddress);
			}
			// checkFeatureFlag('dynamic_home_downtime_banner', user.emailAddress, setDowntimeBanner, setLoading);
			setDowntimeBanner(false);
		}
	}, [user]);

	useEffect(() => {
		!loading && response !== null && setUser(response.payload);
	}, [loading, response]);

	/**
	 * On load
	 * Set the title state
	 * Assign style class to the body element
	 * Check to see if the sub-domain is equal to 'use' then sets the isUseDomain state
	 */
	useEffect(() => {
		setTitle('My Home');
		$('body').addClass('home-version-2');
		setIsUseDomain(window.location.hostname.split('.')[0] === 'use');
	}, []);

	/**
	 * Check to see if the user is on the schools domain.
	 * If they are, remove the Account link from the Account dropdown, since it goes nowhere for schools users.
	 */
	useEffect(() => {
		if (!isUseDomain) {
			$('#account-link').addClass('d-none');
			$('#members-link').addClass('d-none');
		} else {
			$('#account-link').removeClass('d-none');
			$('#members-link').removeClass('d-none');
		}
	}, [isUseDomain]);

	return (
		<Container className={'mt-3 dynamic-page'} fluid={true}>
			{ loading && typeof user.emailAddress === 'undefined' && <Loader /> }
			{ error !== null && <ResponseErrorMessage error={error} /> }
			{
				!loading && response !== null && typeof user.emailAddress !== 'undefined' &&
					<>
						{ downtimeBanner && <DowntimeBanner user={user} /> }
						<Title />
						{ (user.type === 'teacher' || user.type === 'admin') && <FindContentByStandard user={user} /> }
						{ (user.type === 'admin' && !isUseDomain) &&
							<MyAdministratorTools analyticsUrl={user.analyticsUrl} /> }
						{
							user.type === 'student' ?
								<>
									{ !isUseDomain && <MyRecentProducts /> }
									<MyPremiumProducts />
									<MyClassrooms user={user} />
								</> :
								<>
									{ !isUseDomain && <MyRecentProducts /> }
									<MyClassrooms user={user} />
									<MyPremiumProducts />
								</>

						}
						{ !isContentRestricted && <Subjects /> }
						<div className="footer-squiggles"></div>
					</>
			}
		</Container>
	);
};

export default DynamicHome;
